import * as React from 'react'
import { StructuredText, renderNodeRule } from 'react-datocms'

import { Text } from '@factorialco/deprecated-design-system'
import {
  isBlockquote,
  isHeading,
  isList,
  isListItem,
  isParagraph,
} from 'datocms-structured-text-utils'

import * as styles from 'modules/marketplace/components/Description/index.vanilla.css'

type StructuredTextType = {
  id: string | number
  stepByStepDescription: string
}

export const StepByStepDescription = ({ stepByStepDescription, id }: StructuredTextType) => {
  const parsedStepByStepDescription = JSON.parse(stepByStepDescription)

  return (
    <div className={styles.formattedText}>
      <StructuredText
        data={parsedStepByStepDescription}
        key={id}
        customNodeRules={[
          renderNodeRule(isHeading, ({ key, children }) => {
            return (
              <div className={styles.heading} role="heading" key={key}>
                <Text size="500" weight="medium" color="grey1000">
                  {children}
                </Text>
              </div>
            )
          }),
          renderNodeRule(isBlockquote, ({ key, children }) => {
            return (
              <p className={styles.blockquote} key={key}>
                {children}
              </p>
            )
          }),
          renderNodeRule(isList, ({ key, children, node }) => {
            return node.style === 'bulleted' ? (
              <ul className={styles.unorderedList} key={key}>
                {children}
              </ul>
            ) : (
              <ol className={styles.list} key={key}>
                {children}
              </ol>
            )
          }),
          renderNodeRule(isListItem, ({ key, children }) => {
            return (
              <li className={styles.listItem} key={key}>
                {children}
              </li>
            )
          }),
          renderNodeRule(isParagraph, ({ key, children }) => {
            return (
              <p className={styles.paragraph} key={key}>
                {children}
              </p>
            )
          }),
        ]}
      />
    </div>
  )
}
